import React, { Component } from "react";
import $ from "jquery";
import PropTypes from "prop-types";

import { Translate } from "react-redux-i18n";

import Form from "react-bootstrap/Form";

import { momentModule } from "../../utils/Utils";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";

import "../../../styles/components/utils/components/CheckCard.scss";
import friends from "../../../styles/images/friends.svg";
import avatar from "../../../styles/images/avatar.svg";
import arrow from "../../../styles/images/arrow_black.svg";

const { moment, formatDate } = momentModule;

class CheckCard extends Component {
  constructor(props) {
    super(props);
    this._mounted = false;

    this.state = {
      validated: false,
      isDefiningPeriod: false,
      hasDefinedPeriod: false,

      from: "",
      to: "",
    };

    this.setIsDefiningPeriod = this.setIsDefiningPeriod.bind(this);
    this.handleOnDateChange = this.handleOnDateChange.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    if (this.props.checked && this.props.hasOwnProperty("period")) {
      const isValidPeriod =
        this.props.period.period &&
        this.props.period.periodType !== "always" &&
        this.props.period.period.startDate !== null &&
        this.props.period.period.stopDate !== null;
      this.safeSetState({
        hasDefinedPeriod: isValidPeriod,
        from: isValidPeriod ? new Date(this.props.period.period.startDate) : "",
        to: isValidPeriod ? new Date(this.props.period.period.stopDate) : "",
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.hasOwnProperty("period") &&
      this.props.period &&
      this.props.period.hasOwnProperty("period") &&
      this.props.period.period
    )
      if (prevProps.hasOwnProperty("period") && prevProps.period) {
        const startDate =
          this.props.period.period.startDate !== null &&
            moment(this.props.period.period.startDate).isValid()
            ? this.props.period.period.startDate
            : "";
        const stopDate =
          this.props.period.period.stopDate !== null &&
            moment(this.props.period.period.stopDate).isValid()
            ? this.props.period.period.stopDate
            : "";

        if (
          !prevProps.period.hasOwnProperty("period") ||
          prevProps.period.periodType !== this.props.period.periodType ||
          (prevProps.period.hasOwnProperty("period") &&
            prevProps.period.period &&
            startDate !== "" &&
            !moment(startDate).isSame(moment(prevProps.period.period.startDate))) ||
          (prevProps.period.hasOwnProperty("period") &&
            prevProps.period.period &&
            stopDate !== "" &&
            !moment(stopDate).isSame(moment(prevProps.period.period.stopDate)))
        )
          this.safeSetState({
            hasDefinedPeriod: startDate !== "" && stopDate !== "",
            from: startDate !== "" ? new Date(startDate) : "",
            to: stopDate !== "" ? new Date(stopDate) : "",
          });
      }
  }

  componentWillUnmount() {
    this.resetState(() => (this._mounted = false));
  }

  setIsDefiningPeriod(e, bool) {
    this.safeSetState({
      isDefiningPeriod: bool,
    });
  }

  handleOnDateChange(e, date) {
    this.safeSetState({
      [date]: new Date(e.target.value),
    });
  }

  handleOnSubmit(e) {
    e.preventDefault();

    const form = $(e.target)[0];
    this.safeSetState({ validated: true }, () => {
      if (form.checkValidity() !== false) {
        this.safeSetState(
          {
            validated: false,
            isDefiningPeriod: false,
            hasDefinedPeriod: this.state.from && this.state.to ? true : false,
          },
          () => this.props.onSubmit(e, this.state.from, this.state.to)
        );
      }
    });
  }

  resetState(callback) {
    this.safeSetState(
      {
        validated: false,
        isDefiningPeriod: false,
        hasDefinedPeriod: false,
        from: null,
        to: null,
      },
      callback
    );
  }

  safeSetState(params, callback) {
    if (this._mounted) this.setState(params, callback);
  }

  render() {
    const d = moment().startOf("day");

    return (
      <div id="checkCard" className={"card " + this.props.type}>
        <div className="main-container">
          <img
            className="avatar"
            src={
              this.props.avatar
                ? this.props.avatar
                : this.props.type === "period"
                  ? avatar
                  : this.props.defaultAvatar || friends
            }
            alt=""
          />
          <div className="name-container">
            <p className="name">{this.props.name}</p>
            {this.props.type === "info" && <p className="info">{this.props.info}</p>}
            {this.props.type === "period" && (
              <>
                <p className="info">{this.props.info}</p>
                {this.props.checked &&
                  !this.state.isDefiningPeriod &&
                  (this.state.hasDefinedPeriod ? (
                    <>
                      <Translate value="assignDrivers_custom" />
                      <button
                        type="button"
                        className="link"
                        onClick={e => this.setIsDefiningPeriod(e, true)}
                      >
                        {`${formatDate(this.state.from)} - ${formatDate(this.state.to)}`}
                      </button>
                    </>
                  ) : (
                    <>
                      <Translate value="assignDrivers_always" />
                      <button
                        type="button"
                        className="link"
                        onClick={e => this.setIsDefiningPeriod(e, true)}
                      >
                        <Translate value="evs_definePeriod" />
                      </button>
                    </>
                  ))}
              </>
            )}
          </div>

          {this.props.fleet && this.props.collapsed && this.props.fleetEvs.length > 0 && (
            <div className="arrow-icon-container">
              <img src={arrow} alt="" className={this.props.collapsed} />
            </div>
          )}

          <div className="check-container">
            <Form.Control
              as="input"
              type={this.props.hasOwnProperty("checkboxName") ? "radio" : "checkbox"}
              name={this.props.checkboxName}
              checked={this.props.checked}
              onChange={this.props.onChange}
              onClick={e => {
                e.stopPropagation();
              }}
              required={this.props.hasOwnProperty("required")}
            />
            <div className="check" />
          </div>
        </div>
        <div className="period-container">
          {this.state.isDefiningPeriod && (
            <>
              <Form
                id="period-form"
                onSubmit={this.handleOnSubmit}
                validated={this.state.validated}
                noValidate
              >
                <Form.Group className="form-field">
                  <Form.Label htmlFor="dateFrom">
                    <Translate value="checkCard_from" />
                  </Form.Label>
                  <div className="date-container">
                    <Form.Control
                      id="dateFrom"
                      type="date"
                      name="from"
                      min={this.state.from === "" ? moment(d).format("YYYY-MM-DD") : ""}
                      max={this.state.to !== "" ? moment(this.state.to).format("YYYY-MM-DD") : ""}
                      value={this.state.from ? moment(this.state.from).format("YYYY-MM-DD") : ""}
                      onChange={e => this.handleOnDateChange(e, "from")}
                    />
                    <Form.Control
                      id="dateFromText"
                      type="text"
                      name="fromText"
                      isValid={
                        (this.state.from !== "" && this.state.to !== "") ||
                        moment(this.state.to) >= moment(this.state.from)
                      }
                      isInvalid={
                        (this.state.from === "" && this.state.to !== "") ||
                        (this.state.to === "" && this.state.from !== "") ||
                        moment(this.state.to) < moment(this.state.from)
                      }
                      value={this.state.from ? formatDate(this.state.from) : ""}
                      onChange={e => this.handleOnDateChange(e, "from")}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="form-field">
                  <Form.Label htmlFor="dateTo">
                    <Translate value="checkCard_to" />
                  </Form.Label>
                  <div className="date-container">
                    <Form.Control
                      id="dateTo"
                      type="date"
                      name="to"
                      min={moment(this.state.from !== "" ? this.state.from : d).format("YYYY-MM-DD")}
                      value={this.state.to ? moment(this.state.to).format("YYYY-MM-DD") : ""}
                      onChange={e => this.handleOnDateChange(e, "to")}
                    />
                    <Form.Control
                      id="dateToText"
                      type="text"
                      name="toText"
                      isValid={
                        (this.state.from !== "" && this.state.to !== "") ||
                        moment(this.state.to) >= moment(this.state.from)
                      }
                      isInvalid={
                        (this.state.from === "" && this.state.to !== "") ||
                        (this.state.to === "" && this.state.from !== "") ||
                        moment(this.state.to) < moment(this.state.from)
                      }
                      value={this.state.to ? formatDate(this.state.to) : ""}
                      onChange={e => this.handleOnDateChange(e, "to")}
                    />
                  </div>
                </Form.Group>
              </Form>
              <div className="buttons-container">
                <button
                  type="button"
                  className="clear"
                  onClick={() =>
                    this.safeSetState({
                      hasDefinedPeriod: false,
                      from: "",
                      to: "",
                    })
                  }
                >
                  <Translate value="checkCard_clear" />
                </button>
                <button
                  type="button"
                  className="clear"
                  onClick={() => this.safeSetState({ isDefiningPeriod: false })}
                >
                  <Translate value="checkCard_close" />
                </button>
                <button type="submit" className="clear" form="period-form">
                  <Translate value="checkCard_save" />
                </button>
              </div>
            </>
          )}

          {this.props.fleet && this.props.collapsed && this.props.fleetEvs.length > 0 && (
            <div className="fleet-evs-container">
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  {this.props.fleetEvs.map((ev, idx) => (
                    <div className="ev-item" key={idx}>
                      <div className="item-img">
                        <img src={ev.imageContent} alt="ev-logo" />
                      </div>
                      <div className="item-content">
                        <div className="item-content-title">{ev.brand + " " + ev.model}</div>
                        <div className="item-content-plate">{ev.licensePlate}</div>
                      </div>
                    </div>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CheckCard.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string.isRequired,
  avatar: PropTypes.string,
  info: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  period: function (props, propName, componentName) {
    if (
      props["type"] === "period" &&
      (props[propName] === undefined || typeof props[propName] !== "object")
    ) {
      return new Error("Please provide a period object!");
    }
  },
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default CheckCard;
